var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HtmlReader',{attrs:{"id":"castle-conceptbooth"}}),_c('TitleLogo',{attrs:{"title":_vm.$t('page.conceptbooth.title')}}),_c('v-sheet',[_c('ConceptBooth')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }